import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebaseConfig';

import { UserProvider } from './contexts/UserContext';
import PinModal from './components/PinModal';
import RegisterCustomer from './components/Admin/RegisterCustomer';
import ManageCustomers from './components/Admin/ManageCustomers';
import ClinicDashboard from './components/Admin/ClinicDashboard';
import PublicClinicReviews from './components/Admin/PublicClinicReviews';
import PublicClinicLanding from './components/Admin/PublicClinicLanding';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import RegisterAdmin from './components/RegisterAdmin';
import GenerateLink from './components/GenerateLink';
import CustomerPage from './components/CustomerPage';
import AddOffer from './components/AddOffer';
import ViewCustomerLinks from './components/ViewCustomerLinks';
import EditUsers from './components/EditUsers';
import ManageOffers from './components/ManageOffers';
import SystemSuggestions from './components/AiSuggestions';
import CustomerReviews from './components/CustomerReviews';
import AboutLoyalTap from './components/AboutLoyalTap'; // New import!
import AboutLoyalTapLogin from './components/AboutLoyalTapLogin';
import ManageEmployees from './components/ManageEmployees';
import ManageTombola from './components/ManageTombola';


import CustomerTombola from './components/CustomerTombola';
import CustomerReview from './components/CustomerReview'; // Corrected import
import ChatPage from './components/ChatPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import './i18n'; // import before App
import ManageRetailOffers from './components/ManageRetailOffers';
import PublicReviewPage from './components/PublicReviewPage';
import PublicLanding from './components/PublicLanding';
import ManageClinics from './components/Admin/ManageClinics'; // adjust path as needed
import CustomerClinicPage from './components/Admin/CustomerClinicPage';
import ManageClinicVisits from './components/Admin/ManageClinicVisits';
import ClinicVisitsView from './components/Admin/ClinicVisitsView';
import ClinicDashboardLanding from './components/Admin/ClinicDashboardLanding';
import ClinicAiInsights from './components/Admin/ClinicAiInsights';
import MetaAuthCallback from './components/Meta/MetaAuthCallback';
import ConnectMetaPage from './components/Meta/ConnectMetaPage';
import RegisterAsset from './components/AssetManagement/RegisterAsset';
import PublicAssetPage from './components/AssetManagement/PublicAssetPage';
import AdminAssetManager from './components/AssetManagement/AdminAssetManager';
import AssetsReviews from './components/AssetManagement/AssetsReviews';




function App() {
  const [currentUser] = useAuthState(auth);
  
  return (
    <ThemeProvider>
      <CurrencyProvider>
      <UserProvider>
    <Routes>
      <Route path="/" element={<Login />} />

      <Route element={<ProtectedRoute allowedRoles={["system_admin", "owner", "worker"]} />}>
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={["system_admin", "owner_admin"]} />}>
        <Route path="/manage" element={<div>🔧 Manage Page (System Admin, Owner only)</div>} />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={["system_admin"]} />}>
        <Route path="/system-settings" element={<div>⚙️ System Settings (System Admin only)</div>} />
      </Route>
      <Route path="/register-admin" element={<RegisterAdmin />} />

      <Route element={<ProtectedRoute allowedRoles={["system_admin", "owner", "manager", "worker"]} />}>
    <Route path="/generate-link" element={<GenerateLink />} />
</Route>

<Route path="/customer/:token" element={<CustomerPage />} />

<Route element={<ProtectedRoute allowedRoles={["system_admin", "owner", "manager"]} />}>
  <Route path="/add-offer" element={<AddOffer />} />
</Route>
<Route element={<ProtectedRoute allowedRoles={["system_admin", "owner", "manager","worker"]} />}>
  <Route path="/view-customer-links" element={<ViewCustomerLinks />} />
</Route>
<Route path="/edit-users" element={<EditUsers />} />

<Route path="/manage-offers" element={<ManageOffers />} />

<Route path="/AiSuggestions.jsx" element={<SystemSuggestions coffeeShopId={"flexpayz"} />} />
<Route path="/customer-reviews" element={<CustomerReviews />} />
<Route path="/privacy" element={<AboutLoyalTap />} />
<Route path="/manage-employees" element={<ManageEmployees coffeeShopId={"flexpayz"} />} />
<Route
        path="/manage-tombola"
        element={<ManageTombola coffeeShopId={currentUser?.coffee_shop_id} />}
      />
      <Route path="/customer/:token/tombola" element={<CustomerTombola />} />
      <Route path="/customer_review/:token" element={<CustomerReview />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/about-loyaltap" element={<AboutLoyalTapLogin />} />
      <Route path="/manage-retail-offers" element={<ManageRetailOffers />} />
      <Route path="/public-landing" element={<PublicLanding />} />
<Route path="/top-locations" element={<PublicLanding />} />
<Route path="/public-reviews/:id" element={<PublicReviewPage />} />
<Route path="/admin/manage-clinics" element={<ManageClinics />} />
<Route path="/admin/register-customer" element={<RegisterCustomer />} />
<Route path="/customer-clinic/:token" element={<CustomerClinicPage />} />
<Route path="/admin/manage-customers" element={<ManageCustomers />} />
<Route path="/clinic-dashboard/:clinicToken" element={<ClinicDashboard />} />
<Route
  path="/admin/manage-clinic-visits"
  element={
    <ProtectedRoute allowedRoles={['system_admin']}>
      <ManageClinicVisits />
    </ProtectedRoute>
  }
/>

<Route path="/admin/clinic-visits-view" element={<ClinicVisitsView />} />
<Route path="/public-clinic-reviews/:clinicId" element={<PublicClinicReviews />} />
<Route path="/public-clinics-landing" element={<PublicClinicLanding />} />
<Route path="/admin/clinic-ai-insights" element={<ClinicAiInsights />} />
<Route path="/admin/clinic-dashboard" element={<ClinicDashboardLanding />} />
<Route path="/meta-auth-callback/*" element={<MetaAuthCallback />} />
<Route path="/connect-meta" element={<ConnectMetaPage />} />
<Route path="/public-clinic-landing" element={<PublicClinicLanding />} />
<Route path="/register-asset" element={<RegisterAsset />} />
<Route path="/asset/:token" element={<PublicAssetPage />} />
<Route path="/manage-assets" element={<AdminAssetManager />} />
<Route path="/assets-reviews/:token" element={<AssetsReviews />} />


  </Routes>
  </UserProvider>
  </CurrencyProvider>
  </ThemeProvider> 
  );
}

export default App;